export const Hosts = {
  API: process.env.REACT_APP_API_HOST,
}

export const RequestState = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
}

export const Urls = {
  VIDEO: '/',
}

export const Theta = {
    ChainID: process.env.REACT_APP_THETA_NETWORK_ID || 361,
}
